import { useCallback } from "react";
import { HttpCacheGeneral } from "src/http/httpCacheGeneral";
import { PaisLogo } from "src/types";
import {useQuery} from "@tanstack/react-query";

export const usePaisLogo = () => {
  const {data: paisLogos = [], isLoading} = useQuery<PaisLogo[], Error>({
    queryKey: ['logos-paises'],
    queryFn: () => {
      return HttpCacheGeneral.getPaisLogo()
    },
  });

  const getPaisLogoPorCodigo = useCallback((countryCode: number): PaisLogo | undefined => {
    return paisLogos.find(p => p.id === countryCode)
  }, [paisLogos])

  return { getPaisLogoPorCodigo, paisLogos, loading: isLoading}
};
